/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Content/OrderStatuses/Content/OrderStatus/Time"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let orderStatusCreatedAtValueData = fromData.useDataValue({ viewPath,
context: 'order_status',
path: 'created_at',
})
let aggregateData = fromHelpers.formatDate(orderStatusCreatedAtValueData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Time.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-btyT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 size="small"
 text="On"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="order_status.created_at"
 aggregate="helpers.js formatDate"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}